export enum EnergyFlowType {
  Generation = 'Generation',
  Consumption = 'Consumption',
  Storage = 'Storage',
  BiDirectional = 'Bi-Directional',
}
